"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentTerminalControlOfflinePayloadValidation = void 0;
class PaymentTerminalControlOfflinePayloadValidation {
    static isValid(entity) {
        // Validate entity.timestamp for existence and correct type.
        if (entity.timestamp == undefined)
            return false;
        if (!(entity.timestamp instanceof Date))
            return false;
        // Validate entity.transaction_id for existence and correct type.
        if (entity.transaction_id == undefined)
            return false;
        if (typeof entity.transaction_id !== "string")
            return false;
        // Validate entity.payload for existence and correct type.
        if (entity.payload == undefined)
            return false;
        if (typeof entity.payload !== "string")
            return false;
        return true;
    }
}
exports.PaymentTerminalControlOfflinePayloadValidation = PaymentTerminalControlOfflinePayloadValidation;
